import React from 'react'
import { motion } from 'framer-motion'

const ContentPolicyPage = () => {
  return (
    <div className="pt-16 lg:pt-20 min-h-screen">
      <section className="section-padding py-20">
        <div className="container-max max-w-4xl mx-auto">
          <motion.h1 className="text-4xl font-display font-bold text-white mb-6" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>Content Policy</motion.h1>
          <div className="glass-card p-8 space-y-4 text-white/80">
            <p>Our content policy ensures a safe, helpful platform for Wichita music.</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>No hate speech, harassment, or illegal content</li>
              <li>Respect intellectual property; provide attribution where required</li>
              <li>Reviews must be honest and based on real experiences</li>
              <li>Events and listings are subject to moderation and verification</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  )
}

export default ContentPolicyPage

